import {Component, effect, input, output} from '@angular/core';
import { PaginationMeta } from '../../../models/pagination-meta.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-pagination',
    imports: [TranslateModule],
    templateUrl: './pagination.component.html',
    standalone: true,
    styleUrl: './pagination.component.scss'
})
export class PaginationComponent {
  paginationMeta = input<PaginationMeta>();
  loading = input<boolean>(false);

  nextClicked = output()
  previousClicked = output()

  from: number = 0
  to: number = 0

  constructor() {
    effect(() => {
      this.setFromTo(this.paginationMeta()!.current_page-1)
    });
  }

  previous() {
    if(this.loading())
      return

    if (this.from != 0) {
      this.setFromTo(this.paginationMeta()!.current_page-2)
      this.previousClicked.emit()
    }
  }

  next() {
    if(this.loading())
      return

    if (this.to != this.paginationMeta()?.total) {
      this.setFromTo(this.paginationMeta()!.current_page)
      this.nextClicked.emit()
    }
  }

  // GPT generated
  setFromTo(currentPage: number) {
    this.from = currentPage * this.paginationMeta()!.per_page

    // Check if we are on the last page
    if (currentPage === this.paginationMeta()!.last_page) {
      // On the last page, set "to" to the total number of items
      this.to = this.paginationMeta()!.total;
    } else {
      // Otherwise, calculate normally
      this.to = this.from + this.paginationMeta()!.per_page;
    }

    // Handle the case where `to` exceeds the total number of entries
    if (this.to > this.paginationMeta()!.total) {
      this.to = this.paginationMeta()!.total;
    }
  }
}
